
import { loadedComponents_, loadedComponentIsOutOfDate_, Project, LoadedComponent, PortType, Port, Component, ComponentType, CustomComponentType, SheetInfo } from "../Common/CommonTypes.js";
import { writeAllSheetFiles, sheetExtension, sheetFilePath, writeSheetFile } from "../Interface/ComponentLibraries.js";
import { FSharpMap__get_Item, tryFind as tryFind_1, add, fold, ofList, iterate } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { join, concat as concat_1, printf, toFail } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { removeFileWithExtn } from "../Interface/FilesIO.js";
import { signatureOfInstance, compareCanvas } from "../Simulator/CanvasExtractor.js";
import { safeHash, compare, arrayHash, equalArrays, compareArrays, comparePrimitives, stringHash, curry2, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { forAll, fold as fold_2, cons, sort, item as item_1, find, sortBy, mapIndexed, findIndex, length, toArray as toArray_1, filter, choose, concat, ofArray, unzip, head, tail, isEmpty, empty, singleton, collect, append, tryFind, map as map_4 } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { List_except, List_groupBy, List_distinct } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { Msg, Model } from "../Model/ModelType.js";
import { Record, Union } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { list_type, option_type, tuple_type, record_type, int32_type, string_type, union_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { contains, union, toArray, toList as toList_1, FSharpSet_op_Subtraction, intersect, ofSeq } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { MapModule_KeysA } from "../Common/EEExtensions.js";
import { toList, map as map_5 } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { mapOverProject } from "./ModelHelpers.js";
import { instanceBindingExprs, sheetParamSlots, declaredParams } from "../Common/ParameterAnalysis.js";
import { fold as fold_1, append as append_1, collect as collect_1, map as map_6 } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { warn, dbg } from "../Shared/Log.js";
import { IdAllocator_newPortId } from "../Common/Helpers.js";
import { Optic_Map, Optic_Map_op_HatPercent_Z1462312A, Optic_Set, Optic_Set_op_HatEquals_Z147477F8 } from "../Common/Optics.js";
import { defaultArg, value as value_2 } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import * as react from "react";
import { TableOption, table as table_4 } from "../fable_modules/Fulma.3.0.0/Elements/Table.fs.js";
import { Option, h5 } from "../fable_modules/Fulma.3.0.0/Elements/Heading.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { choicePopupFunc } from "../DrawBlock/PopupHelpers.js";
import { openFileInProject$0027 } from "./MenuHelpers.js";

export function getCorrectFileName(project) {
    const matchValue = project.WorkingFileName;
    if (matchValue == null) {
        return project.OpenFileName;
    }
    else {
        return matchValue;
    }
}

/**
 * Save any changed sheets to disk in the project directory
 */
export function syncLoadedComponentsToDisk(newProj, oldProj) {
    const saveToDisk = (ldc_1) => {
        const sheetInfo = new SheetInfo(ldc_1.Form, ldc_1.Description, ldc_1.LCParameterSlots, ldc_1.IsTopSheet, ldc_1.ArrayInfo);
        writeSheetFile(sheetFilePath(newProj, ldc_1.Name), ldc_1.CanvasState, ldc_1.WaveInfo, sheetInfo);
    };
    const nameOf = (sheet, ldc_2) => (ldc_2.Name === sheet);
    const oldLDCs = oldProj.LoadedComponents;
    const newLDCs = newProj.LoadedComponents;
    iterate((name, tupledArg_2) => {
        let ldc$0027, ldc, tupledArg, tupledArg_1;
        const optLdcNew = tupledArg_2[0];
        const optLdcOld = tupledArg_2[1];
        if (optLdcNew == null) {
            if (optLdcOld == null) {
                toFail(printf("What? Can\'t happen"));
            }
            else {
                const ldcOld_2 = optLdcOld;
                removeFileWithExtn(sheetExtension(oldProj), oldProj.ProjectPath, ldcOld_2.Name);
            }
        }
        else if (optLdcOld == null) {
            const ldcNew_2 = optLdcNew;
            saveToDisk(ldcNew_2);
        }
        else if ((ldc$0027 = optLdcNew, (ldc = optLdcOld, ((!((tupledArg = ldc$0027.CanvasState, (tupledArg_1 = ldc.CanvasState, compareCanvas(10, tupledArg[0], tupledArg[1], tupledArg_1[0], tupledArg_1[1])))) ? true : !equals(ldc$0027.WaveInfo, ldc.WaveInfo)) ? true : !equals(ldc$0027.LCParameterSlots, ldc.LCParameterSlots)) ? true : (ldc$0027.IsTopSheet !== ldc.IsTopSheet)))) {
            const ldcNew_1 = optLdcNew;
            const ldcOld_1 = optLdcOld;
            saveToDisk(ldcNew_1);
        }
    }, ofList(map_4((sheet_1) => [sheet_1, [tryFind(curry2(nameOf)(sheet_1), newLDCs), tryFind(curry2(nameOf)(sheet_1), oldLDCs)]], List_distinct(map_4((ldc_3) => ldc_3.Name, append(oldLDCs, newLDCs)), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }));
}

/**
 * Return new model with project updated as per update function.
 * If p.LoadedComponents data is changed, for each sheet that is different
 * the sheet will be saved to disk.
 * This function should be used consistently to keep disk and project data
 * correct.
 */
export function updateProjectFiles(saveToDisk, update, model) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const p = matchValue;
        const p$0027 = update(p);
        if (saveToDisk) {
            syncLoadedComponentsToDisk(p$0027, p);
        }
        return new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, p$0027, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState);
    }
    else {
        return model;
    }
}

export class IODirection extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InputIO", "OutputIO"];
    }
    static InputIO = new IODirection(0, []);
    static OutputIO = new IODirection(1, []);
}

export function IODirection_$reflection() {
    return union_type("CustomCompPorts.IODirection", [], IODirection, () => [[], []]);
}

export class Match extends Record {
    constructor(MLabel, MWidth, MDir) {
        super();
        this.MLabel = MLabel;
        this.MWidth = (MWidth | 0);
        this.MDir = MDir;
    }
}

export function Match_$reflection() {
    return record_type("CustomCompPorts.Match", [], Match, () => [["MLabel", string_type], ["MWidth", int32_type], ["MDir", IODirection_$reflection()]]);
}

export class PortChange extends Record {
    constructor(Direction, Old, New, Message) {
        super();
        this.Direction = Direction;
        this.Old = Old;
        this.New = New;
        this.Message = Message;
    }
}

export function PortChange_$reflection() {
    return record_type("CustomCompPorts.PortChange", [], PortChange, () => [["Direction", IODirection_$reflection()], ["Old", option_type(tuple_type(string_type, int32_type))], ["New", option_type(tuple_type(string_type, int32_type))], ["Message", string_type]]);
}

export function getIOMatchFromSig(inputs, outputs) {
    const makeSig = (dir, ios) => map_4((tupledArg) => (new Match(tupledArg[0], tupledArg[1], dir)), ios);
    return append(makeSig(IODirection.InputIO, inputs), makeSig(IODirection.OutputIO, outputs));
}

/**
 * compare two I/O signature lists
 */
export function ioCompareSigs(sig1_, sig1__1, sig2_, sig2__1) {
    const map = (sg) => ofList(map_4((m) => [[m.MDir, m.MLabel], m], getIOMatchFromSig(sg[0], sg[1])), {
        Compare: (x, y) => (compareArrays(x, y) | 0),
    });
    const ioMap1 = map([sig1_, sig1__1]);
    const ioMap2 = map([sig2_, sig2__1]);
    const ioMap = fold((m_1, key, value) => add(key, value, m_1), ioMap2, ioMap1);
    const matchValue = ofSeq(MapModule_KeysA(ioMap1), {
        Compare: (x_1, y_1) => (compareArrays(x_1, y_1) | 0),
    });
    const set2 = ofSeq(MapModule_KeysA(ioMap2), {
        Compare: (x_2, y_2) => (compareArrays(x_2, y_2) | 0),
    });
    const set1 = matchValue;
    intersect(set1, set2);
    FSharpSet_op_Subtraction(set1, set2);
    FSharpSet_op_Subtraction(set2, set1);
    return map_5((m_2) => {
        let w2, w1, l1_2, l2_2, w1_1, w2_1, l1_3, l2_3;
        const getDetails = (m_3, ioMap_1) => {
            let m_4;
            const option_1 = tryFind_1(m_3, ioMap_1);
            if (option_1 != null) {
                return (m_4 = option_1, [m_4.MLabel, m_4.MWidth]);
            }
            else {
                return undefined;
            }
        };
        const newLW = getDetails(m_2, ioMap1);
        const oldLW = getDetails(m_2, ioMap2);
        return new PortChange(m_2[0], oldLW, newLW, (newLW == null) ? ((oldLW != null) ? "Port and old connections deleted" : toFail(`What? never happens: ${newLW} ${oldLW}`)) : ((oldLW == null) ? "New Port will be added" : (((w2 = (oldLW[1] | 0), (w1 = (newLW[1] | 0), (newLW[0] === oldLW[0]) && (w1 === w2)))) ? ((l1_2 = newLW[0], (l2_2 = oldLW[0], (w1_1 = (newLW[1] | 0), (w2_1 = (oldLW[1] | 0), "No Change"))))) : ((newLW[0] === oldLW[0]) ? ((l1_3 = newLW[0], (l2_3 = oldLW[0], "Port width changed"))) : toFail(`What? never happens: ${newLW} ${oldLW}`)))));
    }, MapModule_KeysA(ioMap));
}

export function guessAtRenamedPorts(matches) {
    let set$_2;
    const matches_1 = toList(matches);
    const portsByKeyFiltered = (ports) => ofList(collect((_arg_1) => {
        let matchResult, item, key;
        if (!isEmpty(_arg_1[1])) {
            if (isEmpty(tail(_arg_1[1]))) {
                matchResult = 0;
                item = head(_arg_1[1]);
                key = _arg_1[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return singleton([key, item]);
            default:
                return empty();
        }
    }, List_groupBy((tupledArg) => [tupledArg[1].Direction, tupledArg[0][1]], ports, {
        Equals: equalArrays,
        GetHashCode: (x) => (arrayHash(x) | 0),
    })), {
        Compare: (x_1, y_1) => (compareArrays(x_1, y_1) | 0),
    });
    const additions = portsByKeyFiltered(collect((_arg_2) => {
        let matchResult_1;
        if (_arg_2.Old == null) {
            if (_arg_2.New != null) {
                matchResult_1 = 0;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0:
                return singleton([[_arg_2.New[0], _arg_2.New[1]], _arg_2]);
            default:
                return empty();
        }
    }, matches_1));
    const deletions = portsByKeyFiltered(collect((_arg_3) => {
        let matchResult_2, m_1, name_1, width_2;
        if (_arg_3.Old != null) {
            if (_arg_3.New == null) {
                matchResult_2 = 0;
                m_1 = _arg_3;
                name_1 = _arg_3.Old[0];
                width_2 = _arg_3.Old[1];
            }
            else {
                matchResult_2 = 1;
            }
        }
        else {
            matchResult_2 = 1;
        }
        switch (matchResult_2) {
            case 0:
                return singleton([[name_1, width_2], m_1]);
            default:
                return empty();
        }
    }, matches_1));
    const patternInput = unzip(map_4((n) => {
        let New, Old;
        return [(New = FSharpMap__get_Item(additions, n)[0], (Old = FSharpMap__get_Item(deletions, n)[0], new PortChange(FSharpMap__get_Item(additions, n)[1].Direction, Old, New, "This appears to be a renamed port, connections will be kept"))), ofArray([FSharpMap__get_Item(additions, n)[1], FSharpMap__get_Item(deletions, n)[1]])];
    }, toList_1(intersect(ofSeq(MapModule_KeysA(additions), {
        Compare: (x_2, y_2) => (compareArrays(x_2, y_2) | 0),
    }), ofSeq(MapModule_KeysA(deletions), {
        Compare: (x_3, y_3) => (compareArrays(x_3, y_3) | 0),
    })))));
    const deletedMatches_1 = concat(patternInput[1]);
    return toArray((set$_2 = FSharpSet_op_Subtraction(ofSeq(matches_1, {
        Compare: (x_4, y_4) => (compare(x_4, y_4) | 0),
    }), ofSeq(deletedMatches_1, {
        Compare: (x_5, y_5) => (compare(x_5, y_5) | 0),
    })), union(ofSeq(patternInput[0], {
        Compare: (x_6, y_6) => (compare(x_6, y_6) | 0),
    }), set$_2)));
}

/**
 * One instance of the current sheet placed on another sheet: where it is, the signature it has,
 * and the signature it OUGHT to have - the sheet inside it resolved at this instance's own
 * parameter bindings. The two differ exactly when the instance needs updating.
 */
export class Instance extends Record {
    constructor(Sheet, CompId, Label, Old, Expected) {
        super();
        this.Sheet = Sheet;
        this.CompId = CompId;
        this.Label = Label;
        this.Old = Old;
        this.Expected = Expected;
    }
}

export function Instance_$reflection() {
    return record_type("CustomCompPorts.Instance", [], Instance, () => [["Sheet", string_type], ["CompId", int32_type], ["Label", string_type], ["Old", tuple_type(list_type(tuple_type(string_type, int32_type)), list_type(tuple_type(string_type, int32_type)))], ["Expected", tuple_type(list_type(tuple_type(string_type, int32_type)), list_type(tuple_type(string_type, int32_type)))]]);
}

/**
 * Every instance of the current sheet, with the signature it has and the one it should have.
 * 
 * An instance's bindings are expressions in the parameters of the sheet it SITS ON - and may be
 * overridden there by a CustomCompParam slot, exactly as in elaboration - so the parent sheet is
 * where they are evaluated. ParameterAnalysis.instanceBindingExprs is the same merge the
 * properties pane and the simulator make.
 */
export function getInstancesOfCurrentSheet(model) {
    return mapOverProject(empty(), model, (p) => {
        const sheetName = getCorrectFileName(p);
        return collect((parentLdc) => {
            const parentBindings = declaredParams(parentLdc);
            const parentSlots = sheetParamSlots(parentLdc);
            return choose((comp) => {
                const matchValue = comp.Type;
                let matchResult, cc_1;
                if (matchValue.tag === 26) {
                    if (matchValue.fields[0].Name === sheetName) {
                        matchResult = 0;
                        cc_1 = matchValue.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0: {
                        const option_1 = signatureOfInstance(p.LoadedComponents, parentBindings, sheetName, instanceBindingExprs(parentSlots, comp, cc_1));
                        if (option_1 != null) {
                            return new Instance(parentLdc.Name, comp.Id, comp.Label, [cc_1.InputLabels, cc_1.OutputLabels], option_1);
                        }
                        else {
                            return undefined;
                        }
                    }
                    default:
                        return undefined;
                }
            }, parentLdc.CanvasState[0]);
        }, filter((ldc) => (ldc.Name !== sheetName), p.LoadedComponents));
    });
}

/**
 * Whether one instance is out of step with what its own bindings give it: it has a port the sheet
 * does not, lacks one the sheet has, or holds one at the wrong width.
 * 
 * The ORDER of the ports is deliberately not compared. An instance's ports are matched to the
 * sheet's Input and Output components by LABEL - by FastCreate when a simulation is elaborated, by
 * SynchronousUtils, and by CanvasStateAnalyser.checkCustomComponentForOkIOs, which compares sets
 * when it decides whether a design is legal - and each port is drawn where the symbol's own saved
 * PortOrder puts it, keyed by port id. So an instance whose ports are in a different order from
 * the sheet's is a correct instance, and reordering it would change nothing that can be seen or
 * simulated.
 * 
 * Requiring the orders to match raised this dialog on four of the five shipped demos, whose
 * instances were placed before the I/O components were moved about on their sheets, and described
 * the difference as a width change - which is what the dialog says when nothing structural
 * happened.
 */
export function instanceIsOutOfDate(inst) {
    const samePorts = (ports, ports$0027) => ofSeq(ports, {
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }).Equals(ofSeq(ports$0027, {
        Compare: (x_1, y_1) => (compareArrays(x_1, y_1) | 0),
    }));
    return !(samePorts(inst.Old[0], inst.Expected[0]) && samePorts(inst.Old[1], inst.Expected[1]));
}

/**
 * The instances of the current sheet that no longer match what their own bindings give them.
 */
export function getOutOfDateDependents(model) {
    return filter(instanceIsOutOfDate, getInstancesOfCurrentSheet(model));
}

/**
 * Return canvasState updated with bad connections that have lost either of their connecting components deleted
 */
export function deleteIncompleteConnections(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const conns = _arg[1];
    const comps = _arg[0];
    const arrayOfIds = (pL) => map_6((p) => p.Id, toArray_1(pL));
    const okPorts = ofSeq(collect_1((comp) => append_1(arrayOfIds(comp.InputPorts), arrayOfIds(comp.OutputPorts)), toArray_1(comps)), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const conns$0027 = filter((conn) => (contains(conn.Source.Id, okPorts) && contains(conn.Target.Id, okPorts)), conns);
    if (!equals(conns, conns$0027)) {
        dbg(128, `${length(conns) - length(conns$0027)} connections deleted`);
    }
    return [comps, conns$0027];
}

/**
 * Change the items x in lst where uPred x with x -> uFunc x.
 * Useful to replace one item of a list
 */
export function listUpdate(uPred, uFunc, lst) {
    return map_4((item) => {
        if (uPred(item)) {
            return uFunc(item);
        }
        else {
            return item;
        }
    }, lst);
}

/**
 * Return updated custom component with ports changed as per change
 * If a port is deleted any corresponding connections must be deleted
 * to keep the CanvasState consistent. That is done elsewhere, since
 * deleting not fully connected connections is a straightforward operation
 * on CanvasState, as done by deleteIncompleteConnections
 */
export function changeInstance(comp, change) {
    const updateInfo = (dir, f, comp_1) => {
        if (dir.tag === 1) {
            let patternInput_2;
            const matchValue_1 = comp_1.Type;
            if (matchValue_1.tag === 26) {
                const ct_2 = matchValue_1.fields[0];
                patternInput_2 = [ct_2.OutputLabels, ct_2];
            }
            else {
                patternInput_2 = toFail(`What? '${matchValue_1}' not allowed`);
            }
            const ct_3 = patternInput_2[1];
            const patternInput_3 = f([patternInput_2[0], comp_1.OutputPorts]);
            return new Component(comp_1.Id, new ComponentType(/* Custom */ 26, [new CustomComponentType(ct_3.Name, ct_3.InputLabels, patternInput_3[0], ct_3.Form, ct_3.ParameterBindings, ct_3.Description)]), comp_1.Label, comp_1.InputPorts, patternInput_3[1], comp_1.X, comp_1.Y, comp_1.H, comp_1.W, comp_1.SymbolInfo, comp_1.SlotInfo);
        }
        else {
            let patternInput;
            const matchValue = comp_1.Type;
            if (matchValue.tag === 26) {
                const ct = matchValue.fields[0];
                patternInput = [ct.InputLabels, ct];
            }
            else {
                patternInput = toFail(`What? '${matchValue}' not allowed`);
            }
            const ct_1 = patternInput[1];
            const patternInput_1 = f([patternInput[0], comp_1.InputPorts]);
            return new Component(comp_1.Id, new ComponentType(/* Custom */ 26, [new CustomComponentType(ct_1.Name, patternInput_1[0], ct_1.OutputLabels, ct_1.Form, ct_1.ParameterBindings, ct_1.Description)]), comp_1.Label, patternInput_1[1], comp_1.OutputPorts, comp_1.X, comp_1.Y, comp_1.H, comp_1.W, comp_1.SymbolInfo, comp_1.SlotInfo);
        }
    };
    const dir_5 = change.Direction;
    const matchValue_2 = change.New;
    const matchValue_3 = change.Old;
    if (equals(matchValue_2, matchValue_3)) {
        return comp;
    }
    else if (matchValue_2 == null) {
        if (matchValue_3 != null) {
            const name_6 = matchValue_3[0];
            const width_4 = matchValue_3[1] | 0;
            const name_2 = name_6;
            return updateInfo(dir_5, (_arg_5) => {
                const labels_8 = _arg_5[0];
                const portNum = findIndex((tupledArg_6) => (tupledArg_6[0] === name_2), labels_8) | 0;
                return [filter((tupledArg_7) => (tupledArg_7[0] !== name_2), labels_8), mapIndexed((i, port_2) => (new Port(port_2.Id, i, port_2.PortType, port_2.HostId)), sortBy((port_1) => port_1.PortNumber, filter((port) => !equals(port.PortNumber, portNum), _arg_5[1]), {
                    Compare: (x, y) => (compare(x, y) | 0),
                }))];
            }, comp);
        }
        else {
            return toFail(`What? Change with new=${matchValue_2} and old = ${matchValue_3} should not be possible`);
        }
    }
    else if (matchValue_3 == null) {
        const name_5 = matchValue_2[0];
        const width_3 = matchValue_2[1] | 0;
        const dir_3 = dir_5;
        const comp_4 = comp;
        return updateInfo(dir_3, (_arg_4) => {
            const ports_6 = _arg_4[1];
            return [append(_arg_4[0], singleton([name_5, width_3])), append(ports_6, singleton(new Port(IdAllocator_newPortId(), length(ports_6), (dir_3.tag === 1) ? PortType.Output : PortType.Input, comp_4.Id)))];
        }, comp_4);
    }
    else if ((matchValue_3[0], matchValue_2[0], matchValue_2[1] === matchValue_3[1])) {
        const newName_2 = matchValue_2[0];
        const oldName_2 = matchValue_3[0];
        const width_2 = matchValue_3[1] | 0;
        const width$0027_1 = matchValue_2[1] | 0;
        return updateInfo(dir_5, (tupledArg_3) => [listUpdate((tupledArg_4) => (tupledArg_4[0] === oldName_2), (tupledArg_5) => [newName_2, tupledArg_5[1]], tupledArg_3[0]), tupledArg_3[1]], comp);
    }
    else if ((matchValue_3[1], matchValue_2[1], matchValue_3[0] === matchValue_2[0])) {
        const name_4 = matchValue_3[0];
        const name$0027_1 = matchValue_2[0];
        const newWidth_2 = matchValue_2[1] | 0;
        const oldWidth_1 = matchValue_3[1] | 0;
        return updateInfo(dir_5, (tupledArg) => [listUpdate((tupledArg_1) => (tupledArg_1[0] === name_4), (tupledArg_2) => [tupledArg_2[0], newWidth_2], tupledArg[0]), tupledArg[1]], comp);
    }
    else {
        const newC = matchValue_2;
        const oldC = matchValue_3;
        return toFail(`What? Change with new=${newC} and old = ${oldC} should not be possible`);
    }
}

/**
 * Bring one instance to the signature its own parameter bindings give it.
 */
export function updateInstance(inst, p) {
    let tupledArg_2, f_1, _arg_2, f_3, _arg_3;
    const newSig = inst.Expected;
    const ldc_1 = find((ldc) => (ldc.Name === inst.Sheet), p.LoadedComponents);
    const patternInput = ldc_1.CanvasState;
    const comps = patternInput[0];
    let comp$0027;
    const comp = fold_1(changeInstance, find((comp_1) => equals(comp_1.Id, inst.CompId), comps), guessAtRenamedPorts((tupledArg_2 = inst.Old, ioCompareSigs(newSig[0], newSig[1], tupledArg_2[0], tupledArg_2[1]))));
    const reorderPorts = (newNames, oldNames, oldPorts) => mapIndexed((i, p_1) => (new Port(p_1.Id, i, p_1.PortType, p_1.HostId)), map_4((n) => item_1(n, oldPorts), map_4((tupledArg) => (findIndex((tupledArg_1) => equals(tupledArg_1[0], tupledArg[0]), oldNames) | 0), newNames)));
    const matchValue = comp.Type;
    if (matchValue.tag === 26) {
        const ct = matchValue.fields[0];
        const currentSig = [ct.InputLabels, ct.OutputLabels];
        if (equalArrays(currentSig, newSig)) {
            comp$0027 = comp;
        }
        else if (equalArrays((f_1 = ((list_3) => sort(list_3, {
            Compare: (x, y) => (compareArrays(x, y) | 0),
        })), (_arg_2 = [currentSig[0], currentSig[1]], [f_1(_arg_2[0]), f_1(_arg_2[1])])), (f_3 = ((list_4) => sort(list_4, {
            Compare: (x_1, y_1) => (compareArrays(x_1, y_1) | 0),
        })), (_arg_3 = [newSig[0], newSig[1]], [f_3(_arg_3[0]), f_3(_arg_3[1])])))) {
            dbg(128, concat_1("reordering the ports of ", comp.Label));
            comp$0027 = (new Component(comp.Id, new ComponentType(/* Custom */ 26, [new CustomComponentType(ct.Name, newSig[0], newSig[1], ct.Form, ct.ParameterBindings, ct.Description)]), comp.Label, reorderPorts(newSig[0], currentSig[0], comp.InputPorts), reorderPorts(newSig[1], currentSig[1], comp.OutputPorts), comp.X, comp.Y, comp.H, comp.W, comp.SymbolInfo, comp.SlotInfo));
        }
        else {
            warn(concat_1("the signature of ", comp.Label, " still does not match after its ports were updated"));
            comp$0027 = comp;
        }
    }
    else {
        comp$0027 = comp;
    }
    return new Project(p.ProjectPath, p.OpenFileName, p.WorkingFileName, cons(new LoadedComponent(ldc_1.Name, ldc_1.TimeStamp, ldc_1.FilePath, ldc_1.WaveInfo, deleteIncompleteConnections(map_4((comp_4) => {
        if (equals(comp_4.Id, inst.CompId)) {
            return comp$0027;
        }
        else {
            return comp_4;
        }
    }, comps), patternInput[1]), ldc_1.InputLabels, ldc_1.OutputLabels, ldc_1.LCParameterSlots, ldc_1.Form, true, ldc_1.Description, ldc_1.IsTopSheet, ldc_1.ArrayInfo), List_except([ldc_1], p.LoadedComponents, {
        Equals: equals,
        GetHashCode: (x_2) => (safeHash(x_2) | 0),
    })));
}

/**
 * Bring every one of these instances to the signature its own parameter bindings give it.
 */
export function updateDependents(instances, p) {
    return fold_2((p_1, instance) => updateInstance(instance, p_1), p, instances);
}

/**
 * Every sheet has just been written to disk from memory, so none of them has unsaved changes.
 * 
 * updateInstance flags each sheet it changes so that the change reaches disk; once it has, the
 * flag has done its job. Left set it made every later "close without saving?" dialog name sheets
 * whose files were already correct, and left the user no way to clear it: the Save button follows
 * the OPEN sheet alone, and an instance is by construction never on that sheet.
 */
export function markProjectSaved(p) {
    let f, mapping;
    return ((f = ((mapping = Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, loadedComponentIsOutOfDate_)(false), (list) => map_4(mapping, list))), Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, loadedComponents_)(f)))(p);
}

export function checkCanvasStateIsOk(model) {
    return mapOverProject(false, model, (p) => {
        const ioNames = map_4((comp_1) => comp_1.Label, filter((comp) => {
            const matchValue = comp.Type;
            switch (matchValue.tag) {
                case 0:
                case 1:
                    return true;
                default:
                    return false;
            }
        }, find((ldc) => (ldc.Name === getCorrectFileName(p)), p.LoadedComponents).CanvasState[0]));
        return length(ioNames) === length(List_distinct(ioNames, {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        }));
    });
}

/**
 * A change to the sheet's ports as the dialog reports it: a port added, deleted or renamed.
 * Widths are deliberately left out - see the module comment - so that one row describes what
 * happened to every instance, however many different widths those instances have.
 */
export class ReportedChange extends Record {
    constructor(Direction, OldName, NewName, Message) {
        super();
        this.Direction = Direction;
        this.OldName = OldName;
        this.NewName = NewName;
        this.Message = Message;
    }
}

export function ReportedChange_$reflection() {
    return record_type("CustomCompPorts.ReportedChange", [], ReportedChange, () => [["Direction", IODirection_$reflection()], ["OldName", option_type(string_type)], ["NewName", option_type(string_type)], ["Message", string_type]]);
}

/**
 * What the user is being asked to confirm, gathered from every out-of-date instance: the ports
 * that came and went, and which instances change only in width.
 * 
 * The structural changes are taken over all instances rather than from a representative one.
 * Instances of a parameterised sheet may be at different widths, so a rename can be guessed for
 * one and not for another; the union is what the sheet's ports actually did.
 */
export function reportedChanges(instances) {
    const changesOf = (inst) => {
        let tupledArg, tupledArg_1;
        return ofArray(guessAtRenamedPorts((tupledArg = inst.Expected, (tupledArg_1 = inst.Old, ioCompareSigs(tupledArg[0], tupledArg[1], tupledArg_1[0], tupledArg_1[1])))));
    };
    const structuralOf = (change) => {
        const nameOf = (option) => {
            const option_1 = option;
            if (option_1 != null) {
                return option_1[0];
            }
            else {
                return undefined;
            }
        };
        const matchValue = nameOf(change.New);
        const matchValue_1 = nameOf(change.Old);
        if (equals(matchValue, matchValue_1)) {
            return undefined;
        }
        else {
            return new ReportedChange(change.Direction, matchValue_1, matchValue, change.Message);
        }
    };
    return [List_distinct(collect((arg) => choose(structuralOf, changesOf(arg)), instances), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), filter((inst_1) => forAll((arg_1) => (structuralOf(arg_1) == null), changesOf(inst_1)), instances)];
}

/**
 * returns a popup function to show the dependents update dialog if this is needed
 * this dialog drives all subsequent work changing custom component instances
 */
export function optCurrentSheetDependentsPopup(model) {
    let p, matchValue, children_16, children_14, children_18, s_11, s_12;
    let sheet;
    const option_1 = model.CurrentProj;
    sheet = ((option_1 != null) ? ((p = option_1, (matchValue = p.WorkingFileName, (matchValue == null) ? p.OpenFileName : (value_2(p.WorkingFileName))))) : undefined);
    if (!checkCanvasStateIsOk(model)) {
        return undefined;
    }
    else {
        const matchValue_1 = getOutOfDateDependents(model);
        if (isEmpty(matchValue_1)) {
            return undefined;
        }
        else {
            const instances = matchValue_1;
            const depSheets = join(",", List_distinct(map_4((inst) => inst.Sheet, instances), {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            }));
            const patternInput = reportedChanges(instances);
            const widthOnly = patternInput[1];
            const structural = patternInput[0];
            const whatChanged = isEmpty(structural) ? (isEmpty(widthOnly) ? "" : "the width of a port on") : "the inputs or outputs of";
            const structuralTable = isEmpty(structural) ? react.createElement("div", {}) : table_4(ofArray([TableOption.IsHoverable, TableOption.IsBordered, TableOption.IsNarrow, new TableOption(/* Props */ 6, [singleton(["style", {
                marginTop: "15px",
            }])])]), ofArray([(children_16 = [(children_14 = map_4((heading) => react.createElement("th", {}, heading), ofArray(["Type", "New port", "Old port", "Change"])), react.createElement("tr", {}, ...children_14))], react.createElement("thead", {}, ...children_16)), (children_18 = map_4((change) => {
                let children_2, children_4, children_6;
                const name = (arg) => defaultArg(arg, "");
                const children_10 = [(children_2 = [equals(change.Direction, IODirection.InputIO) ? "Input" : "Output"], react.createElement("td", {}, ...children_2)), (children_4 = [name(change.NewName)], react.createElement("td", {}, ...children_4)), (children_6 = [name(change.OldName)], react.createElement("td", {}, ...children_6)), react.createElement("td", {}, change.Message)];
                return react.createElement("tr", {}, ...children_10);
            }, structural), react.createElement("tbody", {}, ...children_18))]));
            let widthNote;
            if (isEmpty(widthOnly)) {
                widthNote = react.createElement("div", {});
            }
            else {
                const affected = widthOnly;
                const named = join(", ", map_4((inst_1) => concat_1(inst_1.Label, " on ", inst_1.Sheet), affected));
                const children_22 = [concat_1((length(affected) === 1) ? "This instance is" : "These instances are", " at port widths that no longer follow from their own parameters, and will be corrected: ", named, ".")];
                widthNote = react.createElement("div", {}, ...children_22);
            }
            let body;
            const props_34 = [["style", {
                marginTop: "15px",
            }]];
            const children_24 = [h5(singleton(new Option(/* Props */ 9, [singleton(["style", {
                marginTop: "15px",
            }])])))(singleton(`${sheet}`)), `You have changed ${whatChanged} the current '${sheet}' sheet. `, react.createElement("br", {}), "This dialog will automatically update all dependent sheets to match this. ", react.createElement("br", {}), `The '${sheet}' sheet is instantiated as a symbol ${length(instances)} times in dependent sheets: '${depSheets}'. `, "If you do not automatically update the symbols you will need to delete and recreate each one.", react.createElement("br", {}), (s_11 = "If you automatically update symbols wires that no longer match will be autorouted correctly when you next load each sheet", s_11), react.createElement("br", {}), (s_12 = "Each instance is set to the port widths its own properties give it, so instances at different widths stay at different widths.", s_12), react.createElement("br", {}), widthNote, structuralTable];
            body = react.createElement("div", keyValueList(props_34, 1), ...children_24);
            return choicePopupFunc("Update All Sheet Instances", (_arg_1) => body, "Update all instances", "Save the sheet without updating instances", (isUpdate, dispatch, _arg) => {
                const matchValue_3 = model.CurrentProj;
                let matchResult;
                if (isUpdate) {
                    if (matchValue_3 != null) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0: {
                        let proj;
                        const p_2 = updateDependents(instances, matchValue_3);
                        writeAllSheetFiles(p_2);
                        proj = markProjectSaved(p_2);
                        dispatch(new Msg(/* SetProject */ 39, [proj]));
                        if (proj.OpenFileName !== defaultArg(proj.WorkingFileName, proj.OpenFileName)) {
                            openFileInProject$0027(false, proj.OpenFileName, proj, new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, proj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState), dispatch);
                        }
                        break;
                    }
                }
                dispatch(Msg.ClosePopup);
            });
        }
    }
}

